<template>
  <div class="page-status">
    <div class="status-img">
      <img src="@/assets/images/chengg1@2x.png" alt="" v-if="info.code === 2000 && (mzt === '绿码' || !mzt)" key="statusimg">
      <img src="@/assets/images/shibai1@2x.png" alt="" v-if="info.code === 2000 && (mzt === '黄码' || mzt === '红码')">
      <img src="@/assets/images/shibai1@2x.png" alt="" v-if="info.code !== 2000">
    </div>
    <div class="status-text" v-if="mzt === '绿码' || !mzt" key='success'>
      {{info.code === 2000 ? "预约成功！" : "预约失败！"}}
    </div>
    <div class="status-text" v-else key='success'>
      注意
    </div>
    <div class="status-text" v-if="info.code === 2000 && (mzt === '绿码' || !mzt)">
      入园时请携带身份证，出示二维码
    </div>
     <div class="status-text" v-if="mzt === '黄码' || mzt === '红码'">
       当前状态码为{{mzt}},将无法入园
     </div>
    <div class="status-text mt133" v-if="info.code === 5310">
      当前时段预约人数已满，请更换预约时间。
    </div>
    <div class="status-text mt199" v-if="info.code === 5311">
      该用户已预约成功，请勿重复预约
    </div>
    <div class="status-text mt199" v-if="info.code !== 2000 && info.code !== 5310 && info.code !== 5311">
      {{info.message}}
    </div>
    <div class="status-box" v-if="info.code === 2000">
      <div class="status-item">
        <div class="item-name">{{info.result.siteName}}</div>
        <div class="item-text" v-show="info.result.siteLevelName !== '未定级别'">{{info.result.siteLevelName}}</div>
      </div>
      <div class="status-item">
        <div class="item-text">地址：{{info.result.siteAddress}}</div>
      </div>
      <div class="status-item">
        <div class="item-text">预约时间：{{info.result.rdate}} {{info.result.time}}</div>
      </div>
      <div class="status-item">
        <div class="item-text">预约人：{{info.result.name}}</div>
      </div>
      <div class="qrcode-box">
        <img :src="qrcode">
        <span>核销码：{{info.result.verifyCode}}</span>
      </div>
    </div>
    <div class="status-btn-blue" v-if="info.code === 5310" @click="toForm()">更换预约时段</div>
    <div class="status-btn-white" @click="goBack()" v-if="info.from === 'list'">返回我的预约</div>
    <div class="status-btn-white" @click="toIndex()" v-else>返回预约列表</div>
  </div>
</template>

<script type="text/javascript">
import QRCode from 'qrcode'
export default{
  data () {
    return {
      id: '',
      qrcode: '',
      status: 1,
      info: {},
      mzt: '',
      qrColor: {
        '红码': '#E5361E',
        '黄码': '#F5C43C',
        '绿码': '#1D711D'
      }
    }
  },
  methods: {
    toForm () {
      this.$router.push({
        path: '/edit'
      })
    },
    toIndex () {
      this.$router.push({
        path: '/index'
      })
    },
    goBack () {
      this.$router.go(-1)
    },
    getQRCode (code) {
      let that = this
      QRCode.toDataURL(code, {
        margin: 0,
        color: {
          dark: that.qrColor[that.info.result.mzt] || '#1D711D',
          light: '#FFFFFF'
        }})
        .then(url => {
          that.qrcode = url
        })
        .catch(err => {
          console.error(err)
        })
    }
  },
  mounted () {
    this.info = this.getSession('status')
    this.mzt = this.info.result.mzt
    if (this.info.code === 2000) {
      this.getQRCode(this.info.result.verifyCode)
      document.title = '预约成功'
    } else {
      document.title = '预约失败'
    }
  }
}
</script>

<style type="text/css" lang="scss" scoped>
.page-status{
  width: 100%;
  min-height: 100%;
  box-sizing: border-box;
  padding-bottom: .26rem;
  position: relative;
  background: url('../assets/images/bg-yuyue@2x.png') no-repeat;
  background-size: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  .status-img{
    width: .66rem;
    height: .66rem;
    margin-top: .28rem;
    img{
      width: 100%;
      height: 100%;
      display: block;
    }
  }
  .status-text{
    font-weight: bold;
    font-size: .14rem;
    color: #FFFFFF;
    // margin-left: .1rem;
    ~.status-text{
      margin-top: .05rem;
    }
  }
  .mt133{
    margin-bottom: 1.33rem;
  }
  .mt199{
    margin-bottom: 1.99rem;
  }
  .status-box{
    width: 3.48rem;
    height: 3.9rem;
    background: url('../assets/images/status-bg@2x.png') no-repeat;
    background-size: 100% 100%;
    margin-top: .28rem;
    box-sizing: border-box;
    padding: .2rem .19rem 0;
    margin-bottom: .2rem;
    .status-item{
      width: 100%;
      min-height: .2rem;
      font-size: .14rem;
      color: #666666;
      display: flex;
      align-items: center;
      ~.status-item{
        margin-top: .05rem;
      }
      .item-name{
        font-weight: bold;
        margin-right: .09rem;
      }
    }
    .qrcode-box{
      width: 1.9rem;
      height: 1.9rem;
      background: rgba(235,241,255,1);
      display: flex;
      flex-direction: column;
      align-items: center;
      margin: .51rem auto 0;
      img{
        display: block;
        width: 1.24rem;
        height: 1.24rem;
        margin-top: .195rem
      }
      span{
        font-size: .14rem;
        color: #666666;
        margin-top: .18rem;
      }
    }
  }
  .status-btn-blue{
    width: 1.17rem;
    text-align: center;
    line-height: .36rem;
    height: .36rem;
    box-shadow: 0 2px 4px 0 rgba(67,107,196,0.50);
    border-radius: .18rem;
    font-size: .14rem;
    color: #FFFFFF;
    font-weight: bold;
    background-image: linear-gradient(270deg, #6398FF 0%, #3F80FF 100%);
    margin-bottom: .3rem;
  }
  .status-btn-white{
    width: 1.17rem;
    text-align: center;
    line-height: .36rem;
    height: .36rem;
    border: .01rem solid #7298FF;
    border-radius: .18rem;
    font-size: .14rem;
    color: #5EA0FF;
    font-weight: bold;
    background: #FFFFFF;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/ReservationStatus.vue